import React from "react";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import {Grid, withStyles} from "@material-ui/core";
import MainCalendar from "../components/MainCalendar";
import * as PropTypes from "prop-types";
import MenuBar from './MenuBar';


const styles = theme => ({
    leftBar: {
        width: 300,
        maxWidth: '100vw',
        flex: 1,
        borderRight: '1px solid rgba(0,0,0,0.08)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        [theme.breakpoints.up('sm')]: {
            maxHeight: 'none',
        }
    },
    rightBar: {
        width: 350,
        maxWidth: '100vw',
        flex: 1,
        borderLeft: '1px solid rgba(0,0,0,0.08)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        [theme.breakpoints.up('sm')]: {
            maxHeight: 'none',
        }
    }
})

const SideBars = React.forwardRef((props,ref) => {
    const [menu, setMenu] = props.menu;
    const [calendar, setCalendar] = props.calendar;
    return <div ref={ref}>
        <SwipeableDrawer anchor={'left'} className={props.classes.leftBar} open={menu}
                         onOpen={() => setMenu(true)}
                         onClose={() => setMenu(false)}>
            <Grid xs={12} className={props.classes.leftBar} item>
                <MenuBar menu={props.menu}/>
            </Grid>
        </SwipeableDrawer>
        <SwipeableDrawer anchor={'right'} className={props.classes.rightBar} open={calendar}
                         onOpen={() => setCalendar(true)}
                         onClose={() => setCalendar(false)}>
            <Grid xs={12} className={props.classes.rightBar} item>
                <MainCalendar setCalendar={setCalendar}/>
            </Grid>
        </SwipeableDrawer>
    </div>;
})

SideBars.propTypes = {
    classes: PropTypes.any,
    open: PropTypes.any,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
};

export default withStyles(styles)(SideBars)
